import { render, staticRenderFns } from "./v-form.vue?vue&type=template&id=40313b0b&scoped=true&"
import script from "./v-form.vue?vue&type=script&lang=js&"
export * from "./v-form.vue?vue&type=script&lang=js&"
import style0 from "./v-form.vue?vue&type=style&index=0&id=40313b0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40313b0b",
  null
  
)

export default component.exports